import React, { useRef, useState, useEffect } from 'react'
import { Link, Route, Routes, useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { motion } from 'motion/react'
import { ShinyButton } from './components/ShinyButton'
import Metro from './components/Metro'

const App = () => {
  const constraintsRef = useRef(null)
  const [loading, setLoading] = useState(false)
  const [progress, setProgress] = useState(0)
  const navigate = useNavigate()

  const handleNavigation = () => {
    setLoading(true)
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval)
          setLoading(false)
          navigate('/metro')
          return 100
        }
        return prev + 1
      })
    }, 30)
  }

  return (
    <Wrapper>
      {loading && (
        <Preloader>
          <motion.div
            initial={{ opacity: 1 }}
            animate={{ opacity: 0 }}
            transition={{ delay: 1, duration: 1 }}
            style={{ fontSize: '3rem', fontWeight: 'bold', color: '#fff' }}>
            Loading...
          </motion.div>
          <ProgressBar>
            <Progress style={{ width: `${progress}%` }} />
          </ProgressBar>
          <Percentage>{progress}%</Percentage>
        </Preloader>
      )}
      {!loading && (
        <>
          <Header initial={{ opacity: 0, y: -50 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1 }}>
            Metrospective AI
          </Header>
          <GridContainer>
            <ImageContainer initial={{ opacity: 0, y: -50 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1 }}>
              <img src="/Neon Train Station at Night.jpeg" alt="Description" />
            </ImageContainer>
            <FlexContainer>
              <FlexChild initial={{ opacity: 0, x: 50 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 1 }}>
                Experience the future of metro systems with our innovative app, designed to tackle the most pressing challenges in urban transit. By harnessing
                the power of Artificial Intelligence and Data Analytics, we deliver unparalleled solutions to enhance safety, streamline efficiency, and elevate
                the user experience.
              </FlexChild>
              <FlexChild initial={{ opacity: 0, x: 50 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 1 }} ref={constraintsRef}>
                <motion.div drag dragConstraints={constraintsRef} dragElastic={0.2}>
                  <ShinyButton onClick={handleNavigation}>Get Metro Status</ShinyButton>
                </motion.div>
              </FlexChild>
              <motion.div
                initial={{ x: 100 }}
                animate={{ x: 0 }} // Change x to -50 to move from right to left
                transition={{ duration: 1, delay: 1.5, ease: 'easeInOut' }} // Add easing
                style={{
                  alignSelf: 'flex-end',
                  marginRight: '-2rem'
                }}>
                <img src="/doodle.png" alt="Description" />
              </motion.div>
            </FlexContainer>
          </GridContainer>
        </>
      )}
      <Routes>
        <Route path="/metro" element={<Metro />} />
      </Routes>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  padding-inline: 1rem;
  height: 100vh;
  overflow: auto;
  @media (max-width: 768px) {
    padding-inline: 0.5rem;
  }
`

const Header = styled(motion.h1)`
  padding: 1rem;
  font-size: 5rem;
  @media (max-width: 768px) {
    font-size: 2rem;
    padding: 0.5rem;
  }
`

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  padding: 1rem;
  @media (max-width: 768px) {
    grid-template-columns: 1fr; // Make the grid vertical
    padding: 0.5rem;
  }
`

const ImageContainer = styled(motion.div)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 400px;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 10px 20px;
  }
  @media (max-width: 768px) {
    /* height: 200px; */
    img {
      border-radius: 5px 10px;
    }
  }
`

const FlexContainer = styled.div`
  display: flex;
  flex-direction: column;
  /* justify-content: space-between; */
  @media (max-width: 768px) {
    flex-direction: column;
  }
`

const FlexChild = styled(motion.div)`
  padding: 1rem;
  background-color: #f0f0f0;
  margin: 0.5rem 0;
  font-size: 1.2rem;
  @media (max-width: 768px) {
    font-size: 1rem;
    padding: 0.5rem;
  }
`

const Preloader = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`

const ProgressBar = styled.div`
  width: 80%;
  height: 10px;
  background: #333;
  border-radius: 5px;
  margin-top: 20px;
  @media (max-width: 768px) {
    width: 90%;
  }
`

const Progress = styled.div`
  height: 100%;
  background: linear-gradient(90deg, #ff00ff, #ff66ff, #ff99ff, #ffccff, #ff00ff);
  border-radius: 5px;
`

const Percentage = styled.div`
  margin-top: 10px;
  font-size: 2rem;
  color: #fff;
  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`

export default App
